import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ScrollView } from "native-base";
import { useCallback } from "react";
import { useTranslation } from "@madmedical/i18n";
import DevicesList from "../organisms/DevicesList";
import Headline from "../molecules/Headline";
import Alert from "../molecules/Alert";
import Breadcrumb from "../molecules/Breadcrumb";
import Paper from "../atoms/Paper";
import openExternalUrl from "../util/openExternalUrl";
const Devices = ({ showWebshopAlert, onDismissWebshopAlert }) => {
    const handleWebshopPress = useCallback(() => {
        openExternalUrl("https://www.nexthealth.app/webshop");
    }, []);
    const { t } = useTranslation();
    return (_jsxs(ScrollView, { children: [_jsxs(Paper, Object.assign({ mb: {
                    base: 24,
                    md: 4,
                } }, { children: [_jsx(Headline, { minHeight: 12, borderBottomWidth: 1, borderBottomColor: "gray.100", borderBottomStyle: "solid", leftContent: _jsxs(Breadcrumb, { children: [_jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Link, Object.assign({ route: "devices_connected", params: {} }, { children: t("devices") })) }), _jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Text, { children: t("allDevice") }) })] }) }), _jsx(Headline, { size: "md", title: t("allDevice") }), showWebshopAlert && (_jsx(Box, Object.assign({ px: { base: 4, md: 6 }, mt: { base: 0, md: 4 }, mb: { base: 4, md: 0 }, width: "full" }, { children: _jsx(Alert, { status: "success", iconName: "shoppingBag", title: t("buyDevices"), description: "Szerezz be \u00FAj eszk\u00F6zt a webshopon kereszt\u00FCl!", links: [
                                {
                                    text: "Webshop",
                                    onPress: handleWebshopPress,
                                },
                            ], onDismiss: onDismissWebshopAlert }) }))), _jsx(DevicesList, {})] })), _jsx(Box, { h: 10, w: 1 })] }));
};
export default Devices;
